import { render, staticRenderFns } from "./EditProviderGameForm.vue?vue&type=template&id=67b9ded8&"
import script from "./EditProviderGameForm.vue?vue&type=script&lang=js&"
export * from "./EditProviderGameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports